import { render, staticRenderFns } from "./TelaNovaEditarItemPedido.vue?vue&type=template&id=c4381080&scoped=true&"
import script from "./TelaNovaEditarItemPedido.vue?vue&type=script&lang=js&"
export * from "./TelaNovaEditarItemPedido.vue?vue&type=script&lang=js&"
import style0 from "./TelaNovaEditarItemPedido.vue?vue&type=style&index=0&id=c4381080&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4381080",
  null
  
)

export default component.exports